import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {topoUtils} from '../utils/topo-utils';
import {geoUtils} from '../utils/geo-utils';

class StateCityLabels extends Component {

  shouldComponentUpdate(nextProps) {
    const widthDifferent = nextProps.width !== this.props.width;
    const heightDifferent = nextProps.height !== this.props.height;
    const stateDifferent = nextProps.stateFips !== this.props.stateFips;

    return widthDifferent || heightDifferent || stateDifferent;
  }

  render() {
    const topo = topoUtils.getStateTopography(this.props.stateFips);
    const projection = geoUtils.getAlbersStateProjection(this.props.stateFips, this.props.width, this.props.height);

    // Used to flip left to left of dot if near right edge
    const isNearEdge = d => {
      const point = projection([d.long, d.lat]);
      return point[0] > this.props.width * .8
    };

    return (
      <g className="StateCityLabels">
        {_.map(topo.cities, (d => {
          return (
            <g key={d.city} transform={"translate(" + projection([d.long, d.lat]) + ")"}>

              <circle cx={0} cy={0} r={3.5}></circle>

              <text
                className="outline"
                dy="0.32em"
                textAnchor={isNearEdge(d) ? 'end' : 'start'}
                x={isNearEdge(d) ? -8 : 8}
              >{d.city}</text>

              <text
                dy="0.32em"
                textAnchor={isNearEdge(d) ? 'end' : 'start'}
                x={isNearEdge(d) ? -8 : 8}
              >{d.city}</text>
            </g>);
        }))}
      </g>
    )
  }
}

StateCityLabels.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  stateFips: PropTypes.number
};


export default StateCityLabels


// WEBPACK FOOTER //
// ./src/charts/Map/StateCityLabels.js